import React from 'react'

export const RedCrossIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
      <path d="M0.964968 10.7525L5.37625 6.34122L9.78753 10.7525L10.7525 9.78753L6.34122 5.37625L10.7525 0.964968L9.78753 0L5.37625 4.41128L0.964968 0L0 0.964968L4.41128 5.37625L0 9.78753L0.964968 10.7525Z" fill="#DC372B" />
    </svg>
  )
}
